import { ButtonProps } from "./Button";
import { css, DefaultTheme } from 'styled-components';

export const collectButtonStyles = (props: ButtonProps & { theme: DefaultTheme }) => {
    const variant = props.variant;
    const theme = props.theme;

    const defaultProps = css`
        padding: 9px 10px;
        transition: background-color 200ms, color 200ms, border-color 200ms;
        border-radius: 12px;
        position: relative;
        outline: none;
        box-shadow: none;  
        width: ${props.fullWidth ? "100%" : "auto"};
        height: ${props.fullHeight ? "100%" : "auto"};
        text-transform: ${props.uppercase ? "uppercase" : "none"};
        border: 1px solid;
		font-weight: 500;
		font-size: 16px;
		line-height: 20px;
		cursor: pointer;
        
        @media (hover: none) {
			cursor: default;
        }
    `

    switch (variant) {

        case "disabled":
            return css`
                ${defaultProps};
                background-color: ${theme.colors.button.disable};
                border-color: ${theme.colors.button.disable};
				color: ${theme.colors.button.contrast};
                &:hover {
                    background-color: ${theme.colors.button.disable};
                    color: ${theme.colors.button.contrast};
                    cursor: not-allowed;
                }
                &:active, &:focus {
                    background-color: ${theme.colors.button.disable};
                }
            `
        case "outline":
            return css`
                ${defaultProps};
                background-color: transparent;
                color: ${theme.colors.button.default};
                border: 1px solid ${theme.colors.button.default};
                &:hover {
                    background-color: ${theme.colors.button.hover};
                    border-color: ${theme.colors.button.hover};
                    color: ${theme.colors.button.contrast};
                }
                &:active, &:focus {
                    background-color: ${theme.colors.button.pressed};
					border-color: ${theme.colors.button.pressed};
                }

				@media (hover: none) {
					&:hover {
						background-color: transparent;
						color: ${theme.colors.button.default};
						border: 1px solid ${theme.colors.button.default};
                    }
				}
            `
        case "danger":
            return css`
                ${defaultProps};
                background-color: ${theme.colors.info.error};
				border-color: ${theme.colors.info.error};
                color: ${theme.colors.button.contrast};
                &:hover {
                    background-color: ${theme.colors.info.error};
                }
                &:active, &:focus {
                    background-color: ${theme.colors.info.error};
                }
            `
        case "purple":
            return css`
                ${defaultProps};
                background-color: ${theme.colors.info.purple};
				border-color: ${theme.colors.info.purple};
                color: ${theme.colors.button.contrast};
                &:hover {
                    background-color: ${theme.colors.info.purple};
                }
                &:active, &:focus {
                    background-color: ${theme.colors.info.purple};
                }
            `

        default:
            return css`
                ${defaultProps};
                background-color: ${theme.colors.button.default};
                border-color: ${theme.colors.button.default};
				color: ${theme.colors.button.contrast};
                &:hover {
                    background-color: ${theme.colors.button.hover};
                    border-color: ${theme.colors.button.hover};
                }
                &:active, &:focus {
                    background-color: ${theme.colors.button.pressed};
					border-color: ${theme.colors.button.pressed};
                }

				@media (hover: none) {
					&:hover {
                        background-color: ${theme.colors.button.default};
                        border-color: ${theme.colors.button.default};
                        color: ${theme.colors.button.contrast};
                    }
				}
            `
    }
}